import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { hideToast } from '../../state/uiSlice';

/** Transient confirmation strip — the design's `.toast`. */
export default function Toast() {
  const dispatch = useDispatch();
  const toast = useSelector((s) => s.ui.toast);

  useEffect(() => {
    if (!toast) return undefined;
    const t = setTimeout(() => dispatch(hideToast()), 2600);
    return () => clearTimeout(t);
  }, [toast, dispatch]);

  return <div className={toast ? 'toast show' : 'toast'}>{toast}</div>;
}
